import React from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Link } from 'react-router-dom';
import { Row, Col, Container, Card, CardBody, CardTitle } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import SPMap from './Maps/SPMap';
import { COMPANY } from 'helpers/url_helper';


    const SamplingPointsMap = () => {
        

        return (
            <>
                <div className="page-content">
                    <MetaTags>
                    <title>Water Quality | {COMPANY}</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Row>
                            <Col lg="12">
                            <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">SAMPLING POINTS MAP</h5>   
                                   <SPMap/>
                            </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </>
        );
    }

export default SamplingPointsMap;